module.exports = __webpack_public_path__ + "static/EM0-19840de593bbd46225f41f6d00c40588.jpg";